import { defineMessages } from 'react-intl';

export default defineMessages({
  publisher: {
    id: 'info-overlay.created-by',
    defaultMessage: 'By {author}',
  },
  cast: {
    id: 'info-overlay.cast',
    defaultMessage: 'cast',
  },
  crew: {
    id: 'info-overlay.crew',
    defaultMessage: 'crew',
  },
});



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/player/info-overlay/info/translations.js